import React from "react";

const InputError = ({ error, className }) => {
  return (
    <span className={className ? className : "small text-danger"}>{error}</span>
  );
};

export default InputError;
